import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

const EducationalEnvironment = () => {
    return (
        <section className="edu-env-section py-5">
            <Container>
                <Row className="align-items-center">

                    {/* LEFT CONTENT */}
                    <Col lg={5}>

                        <h2 className="fw-bold">
                            Best Educational<br />
                            Environment
                        </h2>

                        <div className="edu-underline"></div>

                        <p className="edu-text text-muted">
                            Even slightly believable. If you are going use passage of Lorem
                            Ipsum need desire to obtain pain of itself, because it is pain de
                            sires many pain of itself occur for your study
                        </p>

                        <p className="edu-text text-muted">
                            Even slightly believable. If you are going use passage of Lorem
                            Ipsum need desir
                        </p>
                        <Button className="px-4 py-2 rounded-3 btn-grad border-0"> Explore </Button>

                    </Col>

                    {/* RIGHT IMAGES */}
                    <Col lg={7} className="position-relative mt-5 mt-lg-0">
                        <div className="diamond-container">

                            <div className="diamond blue big">
                                <img
                                    src="https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?auto=format&fit=crop&w=600&q=80"
                                    alt="Education"
                                />
                            </div>
                            <div className="diamond blue top">
                                <img src="https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=600&q=80"
                                    alt="Education" />

                            </div>

                            <div className="diamond green left">
                                <img
                                    src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=600&q=80"
                                    alt="Library"
                                />                            </div>

                            <div className="diamond teal bottom">
                                <img
                                    src="https://images.unsplash.com/photo-1529070538774-1843cb3265df?auto=format&fit=crop&w=600&q=80"
                                    alt="Classroom" />
                            </div>

                        </div>
                    </Col>

                </Row>
            </Container>
        </section>
    );
};

export default EducationalEnvironment;
